import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import classNames from 'classnames';
import {Ripple} from "primereact/ripple";
import { Badge } from 'primereact/badge';
import logo from './images/Amphenol_1.png';
import { useStoreState, useStoreActions } from 'easy-peasy';
import { Tooltip } from 'primereact/tooltip';

const AppSubmenu = (props) => {
    const [activeIndex, setActiveIndex] = useState(null)
    const path = useStoreState((actions) => actions.tabModel.path);
    const setMenuIcon = useStoreActions((actions) => actions.projectModel.setMenuIcon);
    const menuIcon = useStoreState((actions) => actions.projectModel.menuIcon);

    const onMenuItemClick = (event, item, index) => {
        //avoid processing disabled items
        if (item.disabled) {
            event.preventDefault();
            return true;
        }

        //execute command
        if (item.command) {
            item.command({ originalEvent: event, item: item });
        }

        if (index === activeIndex)
            setActiveIndex(null);
        else
            setActiveIndex(index);

        if (props.onMenuItemClick) {
            props.onMenuItemClick({
                originalEvent: event,
                item: item
            });
        }
    }

    const onKeyDown = (event) => {
        if (event.code === 'Enter' || event.code === 'Space'){
            event.preventDefault();
            event.target.click();
        }
    }

    const renderLinkContent = (item) => {
        let submenuIcon = item.items && <i className="pi pi-fw pi-angle-down menuitem-toggle-icon"></i>;
        let badge = item.badge && <Badge value={item.badge} />

        return (
            <React.Fragment>
                <i className={item.icon}></i>
                <span>{item.label}</span>
                {submenuIcon}
                {badge}
                <Ripple/>
            </React.Fragment>
        );
    }

    const renderLink = (item, i) => {
        let content = renderLinkContent(item);
        const tooltipId = `menu-item-${i}`; // Unique ID for Tooltip
    
        if (item.to) {
            return (
                <>
                    {/* Tooltip applied to the NavLink */}
                    <NavLink 
                        aria-label={item.label} 
                        onKeyDown={onKeyDown} 
                        role="menuitem" 
                        className="p-ripple menu-item" 
                        activeClassName={!menuIcon ? "layout-router-link-active router-link-exact-active" : "router-link-exact-active-iconBorder"}
                        to={item.to} 
                        onClick={(e) => onMenuItemClick(e, item, i)} 
                        exact 
                        target={item.target}
                        id={tooltipId} // Unique ID for Tooltip Target
                        style={menuIcon ? { width: "39px" } : {}}
                    >
                        <i className={item.icon} />
                        <span className="menu-label">{item.label}</span>
                    </NavLink>
    
                    {/* Tooltip Component - Linked to NavLink */}
                    <Tooltip target={`#${tooltipId}`} content={item.tooltip} position="right" />
                </>
            );
        } 
        else {
            return (
                <>
                    <a 
                        tabIndex="0" 
                        aria-label={item.label} 
                        onKeyDown={onKeyDown} 
                        role="menuitem" 
                        href={item.url} 
                        className="p-ripple" 
                        onClick={(e) => onMenuItemClick(e, item, i)} 
                        target={item.target}
                        id={tooltipId} // Unique ID for Tooltip Target
                    >
                        <i className={item.icon}/>
                        <span className="menu-label">{item.label}</span>
                    </a>
    
                    {/* Tooltip Component - Linked to Anchor */}
                    <Tooltip target={`#${tooltipId}`} content={item.tooltip} position="right" />
                </>
            );
        }
    };
    let items = props.items && props.items.map((item, i) => {
        let active = activeIndex === i;
        let styleClass = classNames(item.badgeStyleClass, {'layout-menuitem-category': props.root, 'active-menuitem': active && !item.to });

        if(props.root) {
            return (
                <li className={styleClass} key={i} role="none">
                    {props.root === true && <React.Fragment>
                        <div className="layout-menuitem-root-text" aria-label={item.label}>{item.label}</div>
                        <AppSubmenu items={item.items} onMenuItemClick={props.onMenuItemClick} />
                    </React.Fragment>}
                </li>
            );
        }
        else {
            return (
                <li className={styleClass} key={i} role="none">
                    {renderLink(item, i)}
                    <CSSTransition classNames="layout-submenu-wrapper" timeout={{ enter: 1000, exit: 450 }} in={active} unmountOnExit>
                        <AppSubmenu items={item.items} onMenuItemClick={props.onMenuItemClick} />
                    </CSSTransition>
                </li>
            );
        }
    });

    return items ? <ul className={props.className} role="menu">{items}</ul> : null;
}

export const AppMenu = (props) => {

    return (
        <div className="layout-menu-container">
            <a className="block" style={{backgroundColor:'#FFFFFF'}}>
               {/* <img src={logo} className='' alt='logo' /> */}
            </a>
            <AppSubmenu items={props.model} className="layout-menu"  onMenuItemClick={props.onMenuItemClick} root={true} role="menu" />
        </div>
    );
}
